t = require('views/internal/teacup-with-helpers')('card_detail')
commentOptions = require('views/templates/comment_options')
memberAvatarTemplate = require './member_avatar'
simpleTest = require 'lib/experiments/simple-test'
sidebarAction = require 'views/templates/card_detail_sidebar_button'

sidebarTemplate = t.renderable ({ editable, showActions, canSubscribe, minimizedCardBack }) ->
  t.div '.window-sidebar', { class: t.classify('card-detail-sidebar-mini': minimizedCardBack) }, ->

    if editable
      t.div '.window-module.u-clearfix', { class: t.classify('card-detail-section-mini': minimizedCardBack) }, ->
        t.h3 '.mod-no-top-margin', { class: t.classify('card-detail-item-header': minimizedCardBack) }, ->
          t.format 'add-to-card'
        t.div '.u-clearfix.card-detail-section-mini-buttons', ->
          sidebarAction('js-change-card-members', 'member', 'members', minimizedCardBack)
          sidebarAction('js-edit-labels', 'label', 'labels', minimizedCardBack)
          sidebarAction('js-add-checklist-menu', 'checklist', 'checklist', minimizedCardBack)
          sidebarAction('js-add-due-date', 'clock', 'due-date', minimizedCardBack)
          sidebarAction('js-attach', 'attachment', 'attachment', minimizedCardBack)

    if !minimizedCardBack
      t.div '.js-plugin-buttons'

    if !editable && showActions && canSubscribe
      t.div '.window-module.u-clearfix', { class: t.classify('card-detail-section-mini': minimizedCardBack) }, ->
        t.h3 '.mod-no-top-margin', { class: t.classify('card-detail-item-header': minimizedCardBack) }, ->
          t.format 'actions'
        t.div '.u-clearfix.card-detail-section-mini-buttons', ->
          t.a '.js-subscribe-sidebar-button', { href: '#' }
          t.a '.js-vote-sidebar-button', { href: '#' }
    else
      t.div '.window-module.other-actions.u-clearfix', { class: t.classify('card-detail-section-mini': minimizedCardBack) }, ->
        t.h3 '.mod-no-top-margin', { class: t.classify('card-detail-item-header': minimizedCardBack) }, ->
          t.format 'actions'
        t.div '.u-clearfix.card-detail-section-mini-buttons', ->
          # NOTE vote and subscribe buttons will have their content
          # rendered as siblings. This is so that you can tab through buttons (all must be anchor tags)
          if minimizedCardBack
            t.span '.js-subscribe-sidebar-button'
            sidebarAction('js-move-card', 'move', 'move', minimizedCardBack)
            sidebarAction('js-copy-card', 'copy', 'copy', minimizedCardBack, true)
            t.span '.js-vote-sidebar-button.hide'
            sidebarAction('js-archive-card', 'archive', 'archive', minimizedCardBack)
            sidebarAction('js-unarchive-card', 'refresh', 'send-to-board', minimizedCardBack)
            sidebarAction('js-delete-card.hide.negate', 'remove', 'delete', minimizedCardBack)
            sidebarAction('js-more-menu', 'overflow-menu-horizontal', 'share-and-more-ellipsis', minimizedCardBack)
          else
            sidebarAction('js-move-card', 'move', 'move', minimizedCardBack)
            sidebarAction('js-copy-card', 'card', 'copy', minimizedCardBack)
            t.span '.js-subscribe-sidebar-button.hide'
            t.span '.js-vote-sidebar-button.hide'
            t.hr()
            sidebarAction('js-archive-card', 'archive', 'archive', minimizedCardBack)
            sidebarAction('js-unarchive-card', 'refresh', 'send-to-board', minimizedCardBack)
            sidebarAction('js-delete-card.hide.negate', 'remove', 'delete', minimizedCardBack)

    if minimizedCardBack
      t.div '.js-plugin-buttons'

    if !minimizedCardBack
      t.div '.window-module.u-clearfix', ->
        t.p '.quiet.u-bottom', ->
          t.a '.quiet-button.js-more-menu', { href: '#' }, ->
            t.format 'share-and-more-ellipsis'


module.exports = t.renderable (data) ->
  { editable, name, canComment, me, loading, showActions, canSubscribe, canToggleDetails, subscribeOnComment, minimizedCardBack } = data

  t.div '.window-cover.hide.js-card-cover-box.js-open-card-cover-in-viewer', ->
    t.div '.window-cover-stickers.js-display-stickers'

  t.div '.window-archive-banner.hide.js-archive-banner', ->
    t.span '.icon-lg.icon-archive.window-archive-banner-icon'
    t.p '.window-archive-banner-text', ->
      t.format 'this-card-is-archived'

  t.div '.window-archive-banner.hide.js-archived-list-banner', ->
    t.span '.icon-lg.icon-archive.window-archive-banner-icon'
    t.p '.window-archive-banner-text', ->
      t.format 'this-card-is-in-an-archived-list'

  t.div '.window-header.mod-card-detail-icons-smaller', ->

    t.span '.window-header-icon.icon-lg.icon-card'

    titleClasses =
      'window-title': true

    t.div { class: t.classify(titleClasses) }, ->

      t.h2 '.card-detail-title-assist.js-title-helper', { dir: 'auto' }

      inputClasses =
        'mod-card-back-title': true
        'js-card-detail-title-input': true

      t.textarea { class: t.classify(inputClasses), disabled: !editable, dir: 'auto' }

    t.div '.window-header-inline-content.hide.quiet.js-current-list'
    t.div '.window-header-inline-content.hide.js-subscribed-indicator-header', ->
      t.icon 'subscribe'

  t.div '.window-main-col.mod-card-detail-icons-smaller', { class: t.classify('card-detail-mini-main': minimizedCardBack) }, ->

    t.div '.card-detail-data.u-gutter', ->

      if minimizedCardBack
        sidebarTemplate(data)

      t.div '.card-detail-item.u-clearfix.hide.js-card-detail-members', ->
        t.h3 '.card-detail-item-header.mod-no-top-margin', ->
          t.format 'members'

        t.div '.js-card-detail-members-list'

      t.div '.card-detail-item.card-detail-item-labels.u-clearfix.hide.js-card-detail-labels', ->
        t.h3 '.card-detail-item-header', ->
          t.format 'labels'

        t.div '.u-clearfix.js-card-detail-labels-list'

      t.div '.card-detail-item.hide.js-card-detail-due-date', ->
        t.h3 '.card-detail-item-header', ->
          t.format 'due-date'

        t.span '.card-detail-badge.card-detail-due-date-badge.js-card-detail-due-date-badge', ->
          t.span '.card-detail-badge-due-date-complete-box.js-card-detail-due-date-badge-complete', ->
            t.span '.icon-sm.icon-check.card-detail-badge-due-date-complete-icon'
          t.text ' '
          t.span '.js-date-text.card-detail-due-date-text'

      t.div '.card-detail-item.hide.js-card-detail-votes', ->
        t.h3 '.card-detail-item-header', ->
          t.format 'votes'

        t.a '.card-detail-badge.is-clickable.js-card-detail-votes-badge.js-show-votes', { href: '#' }

      t.div '.card-detail-item.hide.js-card-detail-age', ->
        t.h3 '.card-detail-item-header', ->
          t.format 'last-updated'

        t.div '.card-detail-badge.date.mod-last-updated.js-card-detail-age-badge'

      t.div '.plugin-detail-badges.js-plugin-badges'
      t.div '.u-clearfix'

    t.div '.window-module', ->

      t.div '.window-module-title.window-module-title-no-divider', ->
        t.span '.icon-description.icon-lg.window-module-title-icon'
        t.h3 '.u-inline-block', ->
          t.format 'description'
        if editable
          t.a '.card-detail-item-header-edit.hide-on-edit.js-show-with-desc.js-edit-desc', { href: '#' }, ->
            t.format 'edit'

      t.div '.u-gutter.js-hide-on-minimize-desc', ->
        t.div { class: t.classify(editable: editable), attr: 'desc' }, ->

          t.div '.description-content.js-desc-content', ->
            t.div '.description-content-fade-button', ->
              t.span '.description-content-fade-button-text', ->
                t.format 'show-full-description'

            t.div '.current.markeddown.hide-on-edit.js-card-desc.js-show-with-desc.hide', { dir: 'auto' }

            if editable
              t.p '.u-bottom.js-hide-on-edit.js-hide-with-desc', ->
                t.a '.card-detail-fake-text-area.hide-on-edit.js-edit-desc.js-hide-with-draft', { href: '#' }, ->
                  t.format 'add-a-more-detailed-description'
                  # t.icon 'description', 'edit-the-description-ellipsis', { class: 'quiet-button-icon' }

              t.div '.card-detail-edit.edit', ->
                t.a '.helper.js-format-help', { href: '#' }, ->
                  t.format 'formatting-help'
                t.textarea '.field.js-description-draft', { placeholder: t.l('add-a-more-detailed-description') }
              t.p '.edits-warning.quiet', ->
                t.format 'you-have-unsaved-edits-on-this-field'
                t.text ' '
                t.a '.js-view-edits', { href: '#' }, ->
                  t.format 'view-edits'
                t.text " - "
                t.a '.js-discard-edits', { href: '#' }, ->
                  t.format 'discard'
              t.p '.edits-error.error', ->
                t.format 'edit-not-saved'

    t.div '.window-module.u-clearfix.js-custom-fields-section.hide', ->
      t.div '.window-module-title.window-module-title-no-divider', ->
        t.span '.window-module-title-icon.icon-lg.icon-custom-field'
        t.h3 '.u-inline-block', ->
          t.format 'custom-fields'

      t.div '.u-gutter', ->
        t.div '.u-clearfix.js-custom-field-detail-badges.custom-field-detail-badges'

    t.div '.js-plugin-card-back-sections'

    t.div '.js-plugin-sections'

    t.div '.window-module.js-trello-attachments-section.trello-attachments-section.u-clearfix.hide', ->

      t.div '.window-module-title.window-module-title-no-divider', ->
        t.span '.window-module-title-icon.icon-lg.icon-board'
        t.h3 '.u-inline-block', ->
          t.format 'trello attachments'

      t.div '.u-gutter', ->
        t.div '.u-clearfix.js-trello-attachments-list'

        t.p '.js-show-fewer-trello-attachments.hide', ->
          t.a '.quiet-button.js-view-some-trello-attachments', { href: '#' }, ->
            t.format 'show-fewer-trello-attachments'

        t.p '.js-show-more-trello-attachments.hide', ->
          t.a '.quiet-button.js-view-all-trello-attachments', { href: '#' }

        if editable
          t.p ->
            t.a '.quiet-button.js-attach-trello-attachment', { href: '#' }, ->
              t.format 'add-trello-attachment-ellipsis'

    t.div '.window-module.js-attachments-section.u-clearfix.mod-card-detail-icons-smaller.hide', ->
      t.div '.window-module-title.window-module-title-no-divider', ->
        t.span '.window-module-title-icon.icon-lg.icon-attachment'
        t.h3 '.u-inline-block', ->
          t.format 'attachments'

      t.div '.u-gutter', ->
        t.div '.u-clearfix.js-attachment-list'

        t.p '.js-show-fewer-attachments.hide', ->
          t.a '.quiet-button.js-view-some-attachments', { href: '#' }, ->
            t.format 'show-fewer-attachments'

        t.p '.js-show-more-attachments.hide', ->
          t.a '.quiet-button.js-view-all-attachments', { href: '#' }

        if editable
          t.p '.js-show-with-attachments.hide', ->
            t.a '.quiet-button.js-attach', { href: '#' }, ->
              t.format 'add-an-attachment-ellipsis'

    t.div '.checklist-list.window-module.js-checklist-list.js-no-higher-edits'

    if canComment
      t.div '.window-module.add-comment-section', ->

        t.div '.window-module-title.window-module-title-no-divider', ->
          t.span '.window-module-title-icon.icon-lg.icon-comment'
          t.h3 ->
            t.format 'add-comment'

          t.span '.editing-members.js-editing-members.hide'

        t.div '.new-comment.js-new-comment.mod-card-back', ->

          if me
            t.div '.member.member-no-menu', ->
              memberAvatarTemplate(me)

          t.form ->
            t.div '.comment-frame', ->
              t.div '.comment-box', ->
                t.textarea '.comment-box-input.js-new-comment-input', { placeholder: t.l('write-a-comment-ellipsis'), tabindex: '1', dir: 'auto' }
                commentOptions editable

            t.div '.comment-controls.u-clearfix', ->
              t.input '.primary.confirm.mod-no-top-bottom-margin.js-add-comment', {
                disabled: 'disabled'
                tabindex: '3'
                type: 'submit'
                value: t.l('save')
              }
              t.span {
                class: t.classify({
                  'comment-subscribe': true,
                  'is-clickable': true,
                  'is-subscribed': subscribeOnComment,
                  'mod-left': t.l('watch-card-for-updates').length > 58,
                  'js-comment-subscribe': true
                })
              }, ->
                t.span '.comment-subscribe-box', ->
                  t.span '.icon-sm.icon-check.comment-subscribe-icon'
                t.div '.comment-subscribe-description', ->
                  t.format 'watch-card-for-updates'

          t.div '.comment-too-long-warning', ->
            t.p ->
              t.format 'your-comment-is-too-long-you-can-add-it-as-a-text-attachment-or-truncate-it'
            t.input '.primary.js-attach-comment', { type: 'submit', value: t.l('add-as-an-attachment'), tabindex: 4 }
            t.input '.js-truncate-comment', { type: 'submit', value: t.l('truncate'), tabindex: 5 }

    t.div '.window-module.mod-card-detail-icons-smaller', ->

      t.div '.window-module-title.window-module-title-no-divider', ->
        t.span '.window-module-title-icon.icon-lg.icon-activity'
        t.h3 ->
          t.format 'activity'
        if canToggleDetails
          t.div '.window-module-title-options', ->
            t.a '.quiet.hide.js-show-details', { href: '#' }, ->
              t.format 'show-details'
            t.a '.quiet.hide.js-hide-details', { href: '#' }, ->
              t.format 'hide-details'

      t.div '.js-list-actions.mod-card-back'

      if loading
        t.div '.spinner.loading.js-loading-card-actions'

      t.p '.u-bottom', ->
        t.a '.show-more.hide.js-show-all-actions', { href: '#' }, ->
          t.format 'show-all-actions-ellipsis'

  if !minimizedCardBack
    sidebarTemplate(data)

  t.p '.dropzone', ->
    t.format 'drop-files-to-upload'

  t.p '.dropzone-limited.attachments-per-card', ->
    t.format 'too-many-attachments-on-card'

  t.p '.dropzone-limited.attachments-per-board', ->
    t.format 'too-many-attachments-on-board'

  t.p '.dropzone-restricted.attachments-restricted', ->
    t.format 'attachments-restricted'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/card_detail.coffee